// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterDocumentsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetEditorUrlWebApiResponseDto,
  RequestUserTokenWebApiResponseDto,
  RetrieveActiveDocumentsWebApiResponseDto,
  SetDocumentRedactionStatusWebApiRequestDto,
} from '../..';

interface GetEditorUrlParams {
  documentId: string;
}

export const CappsRenterDocumentsWebApiHandler_getEditorUrl_Path = '/api/web/renter/v1/documents/getEditorUrl';

export const CappsRenterDocumentsWebApiHandler_getEditorUrl = (getParams: GetEditorUrlParams, client = getClient()) => {
  return httpFrontEndRequest<GetEditorUrlParams, never, GetEditorUrlWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterDocumentsWebApiHandler_getEditorUrl_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_requestUserToken_Path = '/api/web/renter/v1/documents/requestUserToken';

export const CappsRenterDocumentsWebApiHandler_requestUserToken = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RequestUserTokenWebApiResponseDto>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_requestUserToken_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path =
  '/api/web/renter/v1/documents/retrieveActiveDocuments';

export const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RetrieveActiveDocumentsWebApiResponseDto>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Path =
  '/api/web/renter/v1/documents/setDocumentRedactionStatus';

export const CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus = (
  postData: SetDocumentRedactionStatusWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetDocumentRedactionStatusWebApiRequestDto, void>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
